import React, { Component } from "react";
import MUIDataTable from "mui-datatables";
import {
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";
import { Container, Row, Col } from "shards-react";
import axios from 'axios';
import CircularProgress from '@material-ui/core/CircularProgress';
import api from '../common/api';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ViewIcon from '@material-ui/icons/Visibility';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import AccessAlarmsIcon from '@material-ui/icons/AccessAlarms';
import Tooltip from "@material-ui/core/Tooltip";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CustomToolbar from "../common/AddButton";

class MaintenacePlans extends React.Component {

   constructor() {
      super();

      this.state = {
        data: '',
        isLoaded: false,
        maintenance_plans:[]
      }

      this.handleDelete = this.handleDelete.bind(this)
    }

    async componentDidMount() {
      await this.getMaintenancePlans();
    }
   
   getMaintenancePlans(){
     const token = localStorage.getItem('userToken')

     return axios
              .get(api.maintenance_plans().index(),{ headers: {"Authorization" : `Bearer ${token}`} })
              .then(res => {
                this.setState({isLoaded: true, maintenance_plans: res.data})
              })
              .catch(err =>{
                this.setState({isLoaded: true, maintenance_plans: [] })
              })
  }
  handleDelete(e,id){
    e.preventDefault();
    this.state.maintenance_plans.map((val, idx)=>{
        if(val.id === id){
          this.setState({delete_id: val.id})
        }
    })

    var message = ''
    if (id !==''){
        message = 'Está a punto de dar de baja al plan de mantenimiento. ¿Está seguro?'
    } else {
        message = 'Hubo un problema al dar de baja al plan de mantenimiento.'
    }
    this.setState({message: message, dialogOpen: true })
  }

  handleRefresh(e){
    e.preventDefault();
    window.location.href=`/maintenance-plans`
  }

  handleDialogClose(e){
    e.preventDefault();
    this.setState({dialogOpen: false, errors: false, message: '', delete_id: ''})
  }

  confirmDelete() {
      const token = localStorage.getItem('userToken')
    return axios
     .delete(api.maintenance_plans().delete(this.state.delete_id),
     { headers: {"Authorization" : `Bearer ${token}`}}
      )
      .then(res => {
          this.setState({message: 'Plan de mantenimiento dado de baja con éxito!'})
          this.setState({errors: false})
          this.setState({delete_id: ''})
          this.setState({rowId: ''})
      })
      .catch(err =>{
          this.setState({errors: true})
          this.setState({delete_id: ''})
          this.setState({message: 'Ha ocurrido un error al dar de baja el plan. Contacte a su administrador'})
      })

  }

  handleExport = (e, id) => {
    window.location.href = api.maintenance_plans().export(id)    
  }

  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTableCell: {
         root: {
           padding: '0px 8px 0px 8px',
           fontSize: '0.73rem'
          }
        }
      }
  });      

  render(){
     const columns = [
     {
      name: "id",
      label: "Id",
      options: {
       filter: false,
       sort: true,
      }
     },
     {
      name: "name",
      label: "Nombre",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "description",
      label: "Descripción",
      options: {
       filter: true,
       filterType: "textField",
       sort: true,
      }
     },
     {
      name: "Acciones",
      label: "",
      options: {
          filter: false,
          setCellHeaderProps: () => ({ align: 'right' }),
          customBodyRender: (value, tableMeta, updateValue) => {
            const rowId = tableMeta.rowData[0]
            //const rowId = 1
            return (
              <div style={{display: 'block', paddingRight: '15px'}}>
                <Tooltip title="Editar">
                  <Fab color="primary" aria-label="view"  variant="extended" style={{boxShadow: 'none', backgroundColor: "green" }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"/maintenance-plan/"+rowId+"/0"} >
                    <EditIcon fontSize="small" /> 
                  </Fab>
                </Tooltip>
                <Tooltip title="Versiones">
                  <Fab color="primary" aria-label="edit" variant="extended" style={{boxShadow: 'none', backgroundColor: "green" }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"/maintenance-plan-version/" + rowId + "/1"}>
                    <DriveEtaIcon fontSize="small" />
                  </Fab>
                </Tooltip>                  
                <Tooltip title="Ver">
                  <Fab color="secondary" aria-label="edit" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2' href={"/maintenance-plan/"+rowId+"/1"}>
                    <ViewIcon fontSize="small" /> 
                  </Fab>
                </Tooltip>
                <Tooltip title="Dar de baja">
                  <Fab color="primary" aria-label="view" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2'  onClick={(e)=>{this.handleDelete(e, rowId)}}>
                    <DeleteIcon fontSize="small" /> 
                  </Fab>
                </Tooltip>
                <Tooltip title="Vencimientos">
                  <Fab color="primary" aria-label="view" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2'  href={"/maintenance-plan-due-dates/" + rowId}>
                    <AccessAlarmsIcon fontSize="small" /> 
                  </Fab>
                </Tooltip>
                <Tooltip title="PDF">
                  <Fab color="primary" aria-label="view" variant="extended" style={{boxShadow: 'none' }} fontSize="small" className='MuiButtonBase-root MuiFab-sizeSmall mr-2'  onClick={(e)=>{this.handleExport(e, rowId)}}>
                    <PictureAsPdfIcon fontSize="small" /> 
                  </Fab>
                </Tooltip>
              </div>
                )}
          }
     }
    ];

  const options = {
    download: false,
    customToolbar: () => {
      return (
        <React.Fragment>
          <CustomToolbar url="new" />
        </React.Fragment>
      );
    },
    print:false,
    responsive: 'stacked',
    selectableRowsOnClick: true,
    rowsPerPage: 10,
    selectableRows: false,
    textLabels: {
          toolbar: {
            search: "Buscar",
            viewColumns: "Ver columnas",
            filterTable: "Filtros",   
          },
          body: {
              noMatch: this.state.isLoaded ?
                  'No hay resultados' :
                  <CircularProgress />,
          },
          selectedRows: {
            text: "fila(s) seleccionadas"
          },
          viewColumns: {
            title: "Ver columnas",
          },
          pagination: {
            next: "Siguiente",
            previous: "Anteior",
            rowsPerPage: "Cantidad por página:",
            displayRows: "de",      
          },
          filter: {
            all: "Todos",
            title: "Filtros",
            reset: "Limpiar"
          }
      }
  };

   return(
        <React.Fragment> 
        <Container fluid className="main-content-container px-4">
          <Row>
            <Col className="p-2">
              <div>    
                  <Dialog
                    open={this.state.dialogOpen}
                    onClose={(e)=>this.handleDialogClose(e)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                  <DialogTitle id="alert-dialog-title">Baja de Plan de mantenimiento</DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {this.state.message}
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    {(!this.state.errors)?(
                      (this.state.rowId ==='')?
                        <div>
                          <Button onClick={(e)=>this.handleRefresh(e)} color="primary" >
                            Continuar
                          </Button>
                        </div>
                      :
                      <div>
                      <Button onClick={(e)=>this.handleDialogClose(e)} color="primary" autoFocus>
                        Cancelar
                      </Button>
                      <Button onClick={this.confirmDelete.bind(this)} color="primary" >
                        Continuar
                      </Button>
                      </div>
                     )
                    :(
                    <div>
                    <Button onClick={(e)=>this.handleDialogClose(e)} color="primary" >
                      Continuar
                    </Button>
                    </div>
                    )}
                  </DialogActions>
                </Dialog> 
              </div>
              <div>
              <Row>
                <Col className="p-2">

                 <MuiThemeProvider theme={this.getMuiTheme()}>

                  <MUIDataTable
                  title="Lista de Planes de mantenimiento"
                  data={Object.values(this.state.maintenance_plans)}
                  columns={columns}
                  options={options}
                 />
                 <div style={{textAlign: "right"}}>
                   <Button variant="contained" className="mt-3 ml-1 mr-1" color="secondary" href={"/contracts"}>
                      Volver
                    </Button>
                  </div>
                </MuiThemeProvider>
                </Col>
              </Row>
          </div>
        </Col>
      </Row>
    </Container>
    </React.Fragment>
    );
  }

}

export default MaintenacePlans;   